import type { ValidationResult } from '@idem/tipos/validation-result.type';
import type { ValidationOptions } from '@idem/tipos/validation-options.type';

export const validateNoSpecialCharacters = (
  options: ValidationOptions & ValidationResult,
): ValidationResult => {
  if (options.code) {
    return options;
  }
  if (
    options.value &&
    options.value.length > 0 &&
    !/^[A-Za-z0-9 áéíóúÁÉÍÓÚñ]+$/.test(options.value)
  ) {
    return {
      ...options,
      code: 'no-special-characters',
      message: fieldName =>
        `${fieldName.replace(/([A-Z])/g, g => ` ${g.toLowerCase()}`)} solo puede contener letras y números.`,
    };
  }
  return options;
};
